import handleChange from '../../utils/handleChange';
import handleNestedChange from '../../utils/handleNestedChange';
import CharCount from '../charCount/CharCount';
import Tooltip from '../tooltip/Tooltip';
import { ReactComponent as InfoI } from '../../assets/icons/trvto_info.svg';
import './directInput.css';

export default function DirectInput({
    label,
    name,
    value,
    type,
    placeholder,
    setFormData,
    min,
    limit,
    nest,
    disabled,
    minimum,
    max,
    error,
    content
}) {
    return (
        <div className='directInDiv'>
            <label className='directInLabel'>
                {label}

                {content && (
                    <Tooltip content={content} position='top'>
                        <span className='eyeIcon' style={{ marginLeft: '5px' }}>
                            <InfoI color='blue' width={15} height={15} />
                        </span>
                    </Tooltip>
                )}
            </label>
            <div className='directInInputDiv'>
                <input
                    value={value}
                    name={name}
                    onChange={
                        nest ? (e) => handleNestedChange(e, setFormData, nest) : (e) => handleChange(e, setFormData)
                    }
                    type={type}
                    // style={inputCss}
                    className={`directInInput ${error ? 'error-highlight' : ''}`}
                    placeholder={placeholder}
                    disabled={disabled}
                    min={minimum}
                    max={max}
                ></input>
                <CharCount string={value ? value : ''} min={min} limit={limit} />
            </div>
        </div>
    );
}
